export default "__VITE_ASSET__CTF2F330__"